// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__SAnMI","boxTitle":"Qualiphy_boxTitle__ZONZn","box":"Qualiphy_box__3TLPQ","toggleWrap":"Qualiphy_toggleWrap__k9xhn"};